/** Cliente de API tipado del admin: directo a las callables (el admin no pasa por Hosting). */
import { getFunctions, httpsCallable } from 'firebase/functions';
import type { CallableDef, CallableInput, CallableOutput } from '@nuvvu/shared/api';
import type { ZodTypeAny } from 'zod';
import { app } from './firebase.js';
import { env } from './env.js';

const direct = getFunctions(app, env.VITE_FIREBASE_REGION);

export async function call<D extends CallableDef<ZodTypeAny, unknown>>(
  def: D,
  data: CallableInput<D>,
): Promise<CallableOutput<D>> {
  const parsed = def.input.parse(data) as CallableInput<D>;
  const fn = httpsCallable<CallableInput<D>, CallableOutput<D>>(direct, def.name);
  return (await fn(parsed)).data;
}

/** Mensaje legible de un error de callable (código + detalles de validación si los hay). */
export function errorText(e: unknown): string {
  if (e && typeof e === 'object') {
    const err = e as { code?: string; message?: string; details?: { issues?: string[] } };
    const issues = err.details?.issues;
    if (Array.isArray(issues) && issues.length > 0) return issues.join(' · ');
    return `${err.code ?? 'error'}: ${err.message ?? ''}`;
  }
  return String(e);
}
